import PropTypes from "prop-types";

export const elementVisibilityProviderPropTypes = {
  /** Content that will be rendered. */
  children: PropTypes.node.isRequired,

  /** Time in milliseconds to delay triggering onVisible and collect visibility. */
  debounceDelay: PropTypes.number,

  /** Callback that is triggered when elements become visible. */
  onVisible: PropTypes.func.isRequired,

  /** Keep track of elements that become visible for the onVisible callback. */
  rememberVisible: PropTypes.bool,
};
